var map = {
	"./38_Black_scene.jpg": 2835,
	"./38_Freijo_scene.jpg": 9445,
	"./38_White_scene.jpg": 4381,
	"./38_black.png": 6742,
	"./38_freijo.png": 928,
	"./38_white.png": 3896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8521;